/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "./src/components/style.css"
// import "./src/components/font-awesome.css"

require('typeface-lato');
require('typeface-poppins');
require('typeface-heebo');